import { Box, Grid, useMediaQuery } from "@mui/material"

import { makeStyles } from "makeStyles"

import getValueFromLocalizedStringWithFallback from "../../utils/i18n/getValueFromLocalizedStringWithFallback"

import { Category } from "../../typings/Category"
import normalizeLocale from "@secureo/common/utils/normalizeLocale"

const useStyles = makeStyles()({
	headline: {
		display: "block",
	},
	logoPosition: {
		textAlign: "center",
	},
})

const CategoryInformation = ({ category, locale, isBrandCategory }: Props) => {
	const { classes } = useStyles()
	const isSmallerThan815pxs = useMediaQuery("(max-width: 815px)")
	if (!category) return null

	const { language } = normalizeLocale(locale)

	const name = getValueFromLocalizedStringWithFallback(category.nameAllLocales, locale)

	const shortSeoTextAttribute = category.custom?.customFieldsRaw?.find(
		({ name }) => name === "shortSeoText",
	)
	const shortSeoText: string =
		shortSeoTextAttribute?.value?.[language] ?? shortSeoTextAttribute?.value?.de ?? ""

	const base64Svg: string =
		category?.custom?.customFieldsRaw?.find(({ name }) => name === "icon")?.value ?? null

	const shortSeoTextContainsH1Tag = shortSeoText.includes("<h1>")

	return (
		<Box>
			<Grid container spacing={0}>
				{isBrandCategory && (
					<Grid
						item
						xs={12}
						sm={3}
						className={classes.logoPosition}
						style={{
							textAlign: isSmallerThan815pxs ? "left" : "center",
						}}
					>
						<img
							src={base64Svg}
							alt={name}
							style={{
								height: "60px",
								maxHeight: 60,
								width: "100px",
								objectFit: "contain",
								paddingTop: "1rem",
							}}
						/>
					</Grid>
				)}
				<Grid item xs={12} sm={isBrandCategory ? 9 : 12}>
					<section
						style={{ width: "100%", marginBottom: 10 }}
						className="category-information"
					>
						{!shortSeoTextContainsH1Tag && (
							<h1
								style={{
									marginBottom: 5,
									marginTop: 0,
									display: isSmallerThan815pxs ? "none" : "initial",
								}}
								className={classes.headline}
							>
								{name}
							</h1>
						)}
						<div dangerouslySetInnerHTML={{ __html: shortSeoText }} />
					</section>
				</Grid>
			</Grid>
		</Box>
	)
}

interface Props {
	category: Category
	locale: string
	isBrandCategory: boolean
}

export default CategoryInformation
